import MModal from '@mui/joy/Modal';
import JoyModalClose, { ModalCloseProps } from '@mui/joy/ModalClose';
import MModalOverflow from '@mui/joy/ModalOverflow';
import { Close } from '../Icons';
import React from 'react';

export * from '@mui/joy/Modal';
export * from '@mui/joy/ModalOverflow';

export const Modal: typeof MModal = MModal;
export const ModalOverflow: typeof MModalOverflow = MModalOverflow;

// 扩展 ModalClose 组件，使用 Fortress Close 图标
export const ModalClose = React.forwardRef<HTMLButtonElement, ModalCloseProps>(({ children, slots, ...props }, ref) => (
  <JoyModalClose
    ref={ref}
    sx={{
      cursor: 'pointer',
    }}
    slots={{
      root: Close,
      ...slots,
    }}
    {...props}
  >
    {children || <Close />}
  </JoyModalClose>
));

ModalClose.displayName = 'ModalClose';

// 保持向后兼容
export const MModalClose = ModalClose;
